import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, Form, TextArea, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useIsLocalDisabled } from "@/mobile/Settings/Business/Edit/utils/useIsLocalDisabled";
import { useHandleNavigationURL, useSaveToRedux } from "@/mobile/Settings/Business/utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessAddress: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = Form.useForm();
  const isLocalDisabled = useIsLocalDisabled();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const addressApi = useAppSelector((state) => state.user.localInfo?.address);

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        height={"100%"}
        title={`${t("edit")} / ${t("settings.business.postalAddress")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <Form
            onFinish={({ address }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.phone.url,
                fieldName: "address",
                fieldValue: address,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ address: mobileFormEditState.address ?? addressApi }}
          >
            <Form.Item label={t("settings.business.postalAddress")} name="address">
              <TextArea placeholder={t("settings.business.postalAddress")} disabled={isLocalDisabled} />
            </Form.Item>
          </Form>
          <Typography.Text type={"secondary"}>{t("settings.business.instructions.postalAddress")}</Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditBusinessAddress;
